import clsx from 'clsx'
import React, { useRef, useCallback, useMemo, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import styled from 'styled-components'
import { rem } from 'polished'
import { replace, RouterLocation } from 'connected-react-router'
import OfferPageGallery from '../OfferPageGallery'
import Pane from 'components/Common/Pane'
import ScrollAnchor from 'components/Common/ScrollAnchor'
import OfferIntro from './UltraLuxIntro'
import { fetchAvailableRatesForOffer, fetchOfferFlightPrice } from 'actions/OfferActions'
import config from 'constants/config'
import Breakpoint from 'components/Common/Breakpoint'
import FlashHotelHeader from '../FlashHotel/FlashHotelStickyHeader'
import OfferAirportSelect from '../Filters/Airport/OfferAirportSelect'
import OfferAirportSelectBox from '../Filters/Airport/OfferAirportSelectBox'
import LayoutContainer from 'components/Common/LayoutContainer'
import Backdrop from 'components/utils/Backdrop'
import DesktopRelatedTravelItems from 'components/OfferPage/RelatedTravelItems'
import FlashHotelSidebarFilters from '../FlashHotel/FlashHotelSidebarFilters'
import OfferPageStateProvider from 'contexts/OfferPage/offerPageStateProvider'
import { OfferPageActions, OfferPageDispatchAction, OfferPageState } from 'contexts/OfferPage/offerPageStateReducer'
import useMountedEffect from 'hooks/useMountedEffect'
import OfferCalendarDatePickerSelectBox from '../Filters/CalendarPicker/OfferCalendarDatePickerSelectBox'
import OfferCalendarDatePickerSelect from '../Filters/CalendarPicker/OfferCalendarDatePickerSelect'
import { clearBookingCalendar, fetchCalendars, fetchCalendarsByOccupancy } from 'actions/CalendarActions'
import usePrevious from 'hooks/usePrevious'
import useIsAvailableForPurchase from '../hooks/useIsAvailableForPurchase'
import { useSyncHotelTripItem } from 'tripPlanner/hooks/bookmarks/useSyncHotelTripItem'
import { setRecentlyUsedAirportCode } from 'actions/AuthActions'
import { urlHashDatePicker } from 'constants/url'
import { mediaQueryUp } from 'components/utils/breakpoint'
import OfferCapacityWithAgesSelectBox from '../Filters/CapacityWithAges/OfferCapacityWithAgesSelectBox'
import OfferCapacityWithAgesSelect from '../Filters/CapacityWithAges/OfferCapacityWithAgesSelect'
import { getInitialLeOfferPageState } from 'selectors/offerPage/initialOfferPageStateSelectors'
import { generateRoomOccupants, isValidOccupancy, sumUpOccupancies } from 'lib/offer/occupancyUtils'
import ExpiredDealsLereRecommendations from 'components/Recommendations/ExpiredDeals/ExpiredDealsLereRecommendations'
import ImmersiveSaveButtonPortal from 'tripPlanner/components/ImmersiveHeader/ImmersiveSaveButtonPortal'
import BookmarkButton from 'tripPlanner/components/Bookmark/BookmarkButton/BookmarkButton'
import { ISO_DATE_FORMAT } from 'constants/dateFormats'
import { CLEAR_OFFER_CHECK_IN_CHECK_OUT, SET_OFFER_CHECK_IN_CHECK_OUT } from 'actions/actionConstants'
import ProductPaletteProvider from 'contexts/ProductPaletteContext'
import AlwaysOnRoomOptions from '../AlwaysOn/AlwaysOnRoomOptions'
import FlashHotelPackageOptions from '../FlashHotel/FlashHotelPackageOptions'
import useOfferPageReducer from 'hooks/OfferPage/useOfferPageReducer'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import { useSaveHotLead } from 'hooks/Recommendation/useSaveHotLead'
import * as Analytics from 'analytics/analytics'
import { offerPageDurationChangeEvent, offerPageGuestSelectionEvent, offerPageHotLeadEvent } from 'analytics/snowplow/events'
import { multiRoomEnabled } from 'selectors/featuresSelectors'
import MultipleRoomsBookingContent from 'components/OfferPage/MultipleRoomsBooking/MultipleRoomsBookingContent'
import Group from 'components/utils/Group'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import HotelOfferPageStickyFooter from '../HotelOfferPageStickyFooter'
import LuxPlusNotificationBanner from 'luxPlus/components/Banners/LuxPlusNotificationBanner'
import { getIsLuxPlusEnabled } from 'luxPlus/selectors/featureToggle'
import Subtitle from 'components/Luxkit/Typography/Subtitle'
import OfferDurationTabs from '../Filters/DurationTabs/OfferDurationTabs'
import { ReducerMiddleware } from 'lib/redux/reducerUtils'
import { getNextFilterWithCapacityCheckInMiddlware } from '../utils'
import SavePromptHotel from 'tripPlanner/components/Bookmark/SavePrompt/SavePromptHotel'
import { encodeSearchParams } from 'lib/search/searchUtils'
import useShareModalConfig from 'hooks/useShareModalConfig'
import moment from 'moment'
import { useScreenSizeOnly, useScreenSizeUp } from 'hooks/useScreenSize'
import SoftOfferPageWalledGarden from 'components/Common/SoftOfferPageWalledGarden'
import { EmptyArray } from 'lib/array/arrayUtils'
import TripGuard from 'tripPlanner/components/TripGuard/TripGuard'
import useOptimizelyExperiment from 'hooks/Optimizely/useOptimizelyExperiment'
import { OptimizelyExperiments } from 'constants/optimizely'
import HotelFlightsToggleButton from '../Accommodation/HotelFlightsToggle/HotelFlightsToggleButton'
import AlwaysOnRoomOptionsMobile from '../AlwaysOn/MobileBookingFlow/AlwaysOnRoomOptionsMobile'
import FlashHotelPackageOptionsVariant from '../FlashHotel/FlashHotelMobileVariant/FlashHotelPackageOptionsVariant'
import AccommodationOfferPageStickyFooter from 'components/OfferPage/Accommodation/AccommodationOfferPageStickyFooter'
import AccommodationOfferPageStickyHeaderMobile from 'components/OfferPage/Accommodation/AccommodationOfferPageStickyHeaderMobile'
import { getCheapestSelectedPackageOptionWithDefault } from 'selectors/offerPage/offerPageSelectors'
import { MINIMUM_DISCOUNT_TO_SHOW_PERCENTAGE_BADGE } from 'constants/content'
import OfferPageSignUpWall from 'components/Common/OfferPageSignUpWall'
import useEuropeOfferPageWalledGarden from 'hooks/OfferPage/useEuropeOfferPagWalledGarden'
import FlashMobileStickyHeaderFilters from '../FlashHotel/FlashHotelMobileVariant/FlashMobileStickyHeaderFilters'
import accommodationMobileFilterMiddleware from 'components/OfferPage/Accommodation/AccommodationMobileFilterMiddleware'
import { OFFER_TYPE_ALWAYS_ON, OFFER_TYPE_HOTEL } from 'constants/offer'
import AlwaysOnSidebarFilters from '../AlwaysOn/AlwaysOnSidebarFilters'
import AlwaysOnMobileStickyHeaderFilters from '../AlwaysOn/MobileBookingFlow/AlwaysOnMobileStickyHeaderFilters'

const RelativeBlock = styled.form`
  position: relative;
`

const BarShadow = styled(Pane)`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  pointer-events: none;
`

const PackageOptionsPane = styled(Pane)`
  padding: ${rem(20)} 0;
`

const DesktopFilterBlock = styled(Group)`
  &.open {
    position: relative;
    z-index: 3;
  }
`

const StyledFlashHotelStickyHeader = styled(FlashHotelHeader)`
  position: relative;

  &.hideOnMobile.hideOnMobile {
    display: none;

    ${mediaQueryUp.tablet} {
      display: flex;
      visibility: visible;
    }
  }
`

const FlexGroup = styled(Group)`
  flex-grow: 1;
`

const FlexDesktopFilterBlock = styled(DesktopFilterBlock)`
  flex-grow: 1;
`

const defaultMiddlewares: Array<ReducerMiddleware<OfferPageState, OfferPageDispatchAction>> = [getNextFilterWithCapacityCheckInMiddlware]
const mobileVariantMiddlewares:Array<ReducerMiddleware<OfferPageState, OfferPageDispatchAction>> = [accommodationMobileFilterMiddleware]

type CartDefaults = Partial<OfferPageState>

interface Props {
  defaults: CartDefaults;
  offer: App.HotelOffer;
  originAirports?: Array<App.Airport>;
  airports?: Array<App.Airport>;
  routerLocation: RouterLocation<unknown>;
  currency: string;
  headlessMode: boolean;
  isLuxPlusEnabled: boolean;
  isMultiRoomEnabled: boolean;
  routeHistory: App.RouteHistoryState;
}

const fallbackRooms = [generateRoomOccupants()]

function UltraLuxContent({
  offer,
  originAirports = EmptyArray,
  airports = EmptyArray,
  defaults,
  routerLocation,
  headlessMode,
  isMultiRoomEnabled,
  isLuxPlusEnabled,
  routeHistory,
}: Props) {
  const {
    id,
    packages,
  } = offer

  // calendars only start fetching once the user has tried to look at dates
  // after that, try keep the calendars up to date
  const [viewedDates, setViewedDates] = useState(!!defaults.checkInDate)
  const [middlewares, setMiddlewares] = useState(defaultMiddlewares)

  const [state, stateDispatch] = useOfferPageReducer({
    ...defaults,
    duration: defaults.duration ?? offer.lowestPricePackage?.duration,
    offer,
    flights: offer.bundledWithFlightsOnly,
  }, middlewares)

  const bestPackage = useAppSelector(appState => getCheapestSelectedPackageOptionWithDefault(appState, state))
  const { pricing, pricingWithFlights } = bestPackage
  const shouldShowDiscountPercent = pricing.discountPercent >= MINIMUM_DISCOUNT_TO_SHOW_PERCENTAGE_BADGE
  const shouldShowBundledDiscountPercent = pricingWithFlights && pricingWithFlights.discountPercent >= MINIMUM_DISCOUNT_TO_SHOW_PERCENTAGE_BADGE
  const showDiscountPill = !offer?.isDiscountPillHidden && (shouldShowDiscountPercent && !offer.bundledWithFlightsOnly) || (offer.bundledWithFlightsOnly && shouldShowBundledDiscountPercent)
  const loggedOutSavedPercent = showDiscountPill ? offer.bundledWithFlightsOnly ? pricingWithFlights?.discountPercent : pricing.discountPercent : undefined

  const {
    airport,
    duration,
    activeFilter,
    rooms = fallbackRooms,
    package: selectedPackage,
    checkInDate,
    flights,
    activeHeaderFilter,
  } = state

  const dispatch = useAppDispatch()
  const packageOptionsAnchor = useRef<HTMLDivElement>(null)
  const desktopFilterBlockRef = useRef<HTMLDivElement>(null)
  const scrollAfterFilterClose = useRef<boolean>(false)
  const previousFilter = usePrevious(activeFilter)
  const lastFetchedRooms = useRef<Array<App.RoomOccupants> | null>(null)
  const lastFetchedAirport = useRef<App.Airport | null>(null)
  const canBookMultiRoomTypes = isMultiRoomEnabled && rooms.length > 1

  const isMobileDevice = useScreenSizeOnly('mobile')
  const isLPCNewMobileBookingFlowEnabled = useOptimizelyExperiment(OptimizelyExperiments.croAlwaysOnNewMobileBooking, isMobileDevice && offer.type === OFFER_TYPE_ALWAYS_ON)
  const useLPCNewMobileBookingFlow = isMobileDevice && isLPCNewMobileBookingFlowEnabled
  const showHotelAndFlightsToggle = !isMobileDevice && !offer.bundledWithFlightsOnly && offer.offerFlightsEnabled && config.businessTraveller.currentAccountMode !== 'business'

  const [stickyFooterVisible, setIsStickyFooterVisible] = useState<boolean>(true)
  const onStickyFooterToggle = useCallback((visible: boolean) => {
    setIsStickyFooterVisible(visible)
  }, [])

  useSyncHotelTripItem(state, offer)
  const isWalledGardenEuropeOffersEnabled = useEuropeOfferPageWalledGarden()

  const checkInMoment = useMemo(() => checkInDate ? moment(checkInDate) : undefined, [checkInDate])
  const checkOutDate = useMemo(() => checkInMoment?.clone().add(duration, 'days').format(ISO_DATE_FORMAT), [checkInMoment, duration])

  const queryString = useMemo(() =>
    encodeSearchParams({
      urlSearch: routerLocation.search,
      dates: {
        checkIn: checkInDate,
        checkOut: checkOutDate,
      },
      rooms,
    }).toString(), [checkInDate, checkOutDate, rooms, routerLocation.search])

  useEffect(() => {
    if (isMobileDevice) {
      setMiddlewares(mobileVariantMiddlewares)
    } else {
      setMiddlewares(defaultMiddlewares)
    }
  }, [isMobileDevice])

  // Need to pass the context state above the tree
  useEffect(() => {
    dispatch({
      type: SET_OFFER_CHECK_IN_CHECK_OUT,
      payload: {
        offerId: offer.id,
        checkIn: checkInDate,
        checkOut: checkOutDate,
        duration,
        rooms,
      },
    })

    return
  }, [dispatch, offer.id, checkInDate, duration, rooms, checkOutDate])

  useEffect(() => {
    // clear the check in/check out on unmount
    return () => {
      dispatch({
        type: CLEAR_OFFER_CHECK_IN_CHECK_OUT,
        payload: {
          offerId: offer.id,
        },
      })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (routerLocation.query.roomTypeId && routerLocation.query.roomRateId) {
      const roomOption = { roomTypeId: routerLocation.query.roomTypeId, roomRateId: routerLocation.query.roomRateId }
      stateDispatch({ type: OfferPageActions.setRoomOption, roomOption })
    }
  }, [routerLocation.query.roomTypeId, routerLocation.query.roomRateId, stateDispatch])

  const isTabletScreenSizeAndUp = useScreenSizeUp('tablet')
  // 'auto' scroll (not from a user action) only occurs on tablet and up sizes
  // as we don't want the users scroll to lose their position on mobile
  const autoScrollToFilters = useCallback(() => {
    if (isTabletScreenSizeAndUp) {
      requestAnimationFrame(() => {
        desktopFilterBlockRef.current?.scrollIntoView({ behavior: 'auto' })
      })
    }
  }, [isTabletScreenSizeAndUp])

  const scrollToPackageOptions = useCallback(() => {
    packageOptionsAnchor.current?.scrollIntoView()
  }, [])

  const fetchCalendarData = useCallback(() => {
    if (!offer.packages.length || !isValidOccupancy(...rooms)) {
      // if we have any invalid ages or no packages, don't try fetch - it'll fail anyway
      return
    }

    if (canBookMultiRoomTypes) {
      dispatch(fetchCalendarsByOccupancy(id, {
        occupants: rooms,
        flightOrigin: airport?.code,
        packages: offer.packages.filter(p => p.duration === duration),
      }))
    } else {
      dispatch(fetchCalendars(id, {
        occupants: rooms,
        flightOrigin: airport?.code,
        packages: [selectedPackage as App.HotelPackage ?? offer.lowestPricePackage],
      }))
      dispatch(fetchCalendars(id, {
        occupants: rooms,
        flightOrigin: airport?.code,
        packages: offer.packages.filter(p => p.duration === duration),
      }))
    }

    lastFetchedRooms.current = rooms
    lastFetchedAirport.current = airport ?? null
  }, [airport, canBookMultiRoomTypes, dispatch, duration, id, offer, rooms, selectedPackage])

  useEffect(() => {
    const hasRooms = rooms !== fallbackRooms
    const hasDate = !!checkInDate
    if (previousFilter === 'capacity' &&
        !hasRooms &&
        !activeFilter
    ) {
      autoScrollToFilters()
      scrollAfterFilterClose.current = false
    }

    if (activeFilter) {
      autoScrollToFilters()
    }

    if (previousFilter && !activeFilter && hasRooms && hasDate) {
      if (scrollAfterFilterClose.current) {
        if (state.room) {
          window.location.hash = state.room.id
        } else {
          autoScrollToFilters()
        }
      }
      scrollAfterFilterClose.current = false
    }

    if ((activeFilter === 'checkin' || activeHeaderFilter === 'checkin') && !viewedDates) {
      setViewedDates(true)
      fetchCalendarData()
    } else {
      if (viewedDates && (lastFetchedAirport.current !== airport || (!canBookMultiRoomTypes && lastFetchedRooms.current !== rooms))) {
        // rooms/airport has changed, all loaded calendars are no longer valid as we load calendars for a specific
        // combinations of flight origin (flight prices) and rooms (availablity), so clear them
        dispatch(clearBookingCalendar())
        fetchCalendarData()
      } else if (canBookMultiRoomTypes && lastFetchedRooms.current !== rooms) {
        // if multiple room booking is available and we changed the rooms,
        // don't clear the previous data, just update for the new changed
        // rooms (is filtered inside fetchCalendarsByOccupancy action)
        fetchCalendarData()
      }
    }
  }, [activeFilter, activeHeaderFilter, fetchCalendarData]) // eslint-disable-line react-hooks/exhaustive-deps

  const hotLead = useSaveHotLead({
    offerId: id,
    offerType: offer.type,
    checkInDate: state.checkInDate,
    duration,
    occupancy: rooms,
    defaultOccupancy: fallbackRooms,
  })

  useEffect(() => {
    if (hotLead?.checkIn && hotLead.checkOut) {
      Analytics.trackEvent(offerPageHotLeadEvent(offer, state))
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hotLead])

  useMountedEffect(() => {
    if (state.rooms) {
      Analytics.trackEvent(offerPageGuestSelectionEvent(offer, state))
    }
  }, [state.rooms])

  useMountedEffect(() => {
    stateDispatch({ type: OfferPageActions.setOffer, offer })
  }, [offer])

  useEffect(() => {
    // once we load packages and have dates, get our calendar data
    if (viewedDates && offer.packages) {
      fetchCalendarData()
    }
  // eslint-disable-next-line
  }, [offer.packages])

  useMountedEffect(() => {
    // effectively listening on 'on duration change' event
    if (viewedDates) {
      fetchCalendarData()
    }

    if (!activeFilter) {
      autoScrollToFilters()
    }

    if (offer) {
      Analytics.trackEvent(offerPageDurationChangeEvent(offer, state))
    }
  }, [duration])

  useMountedEffect(() => {
    // effectively an 'on airport change' event
    if (airport) {
      dispatch(setRecentlyUsedAirportCode(airport.code))
      dispatch(fetchOfferFlightPrice(id, airport.code))
    }
  }, [airport])

  useEffect(() => {
    if (routerLocation.hash === urlHashDatePicker) {
      stateDispatch({ type: OfferPageActions.toggleFilter, filter: 'checkin' })
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    dispatch(replace({ ...routerLocation, search: queryString }))
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryString])

  const hasSelectedPackageWithDifferentDuration = selectedPackage && selectedPackage?.duration !== duration
  useEffect(() => {
    const hasDate = !!checkInDate && !!checkOutDate
    const useDynamicCancellationPolicies = offer.property.useDynamicCancellationPolicies ?? false
    const occupanciesInvalid = rooms.some(item => item.childrenAge?.some(age => age < 0))
    if (hasDate && !occupanciesInvalid && (!activeFilter || hasSelectedPackageWithDifferentDuration) && useDynamicCancellationPolicies) {
      dispatch(fetchAvailableRatesForOffer(
        offer,
        {
          occupants: rooms,
          checkIn: checkInDate,
          checkOut: checkOutDate,
          flightOrigin: airport?.code,
        },
      ))
    }
  }, [duration, activeFilter, checkInDate, offer, hasSelectedPackageWithDifferentDuration, dispatch, rooms, airport, checkOutDate])

  const occupancyNumber = useMemo(() => sumUpOccupancies(rooms), [rooms])

  const occupancyLimits = useMemo(() => {
    return packages.flatMap((p) => p.roomRate.capacities)
  }, [packages])

  const isValidRoomOccupancy = offer.bundledWithFlightsOnly || occupancyNumber < 10
  const destinationAirport = useMemo(() => airports.find(({ code }) => code === offer.flightDestinationPort), [airports, offer.flightDestinationPort])
  const showFlightInformation = destinationAirport && (originAirports.length > 1 || (originAirports.length > 0 && destinationAirport.code !== airport?.code)) && isValidRoomOccupancy && config.businessTraveller.currentAccountMode !== 'business'
  const availableForPurchase = useIsAvailableForPurchase(state)

  const hideSoldOutOnMobile = !availableForPurchase && config.LERE_EXPIRED_DEALS_V2_ENABLED

  const desktopFiltersWrapperRef = useRef<HTMLDivElement>(null)

  const location = [offer.locationHeading, offer.locationSubheading].filter(t => t).join(', ')

  const shareConfig = useShareModalConfig({
    image: offer.images[0],
    offerId: offer.id,
    location,
    type: 'offer',
    utmCampaign: 'webshare',
    queryString,
    offerType: 'hotel',
  })

  // Do not show the Expired recommendation when it comes from my escapes
  const prevPath = routeHistory.prevPath
  const shouldShowLere = !prevPath.includes('/my-escapes/order')

  return (
    <ProductPaletteProvider product={offer}>
      <OfferPageStateProvider state={state} dispatch={stateDispatch}>
        <ImmersiveSaveButtonPortal>
          <BookmarkButton offer={offer} />
        </ImmersiveSaveButtonPortal>
        <TripGuard>
          <SavePromptHotel offer={offer} />
        </TripGuard>
        <RelativeBlock onSubmit={(e) => e.preventDefault()}>
          {isMobileDevice && availableForPurchase && <AccommodationOfferPageStickyHeaderMobile>
            {offer.type === OFFER_TYPE_HOTEL && <FlashMobileStickyHeaderFilters />}
            {offer.type === OFFER_TYPE_ALWAYS_ON && <AlwaysOnMobileStickyHeaderFilters />}
          </AccommodationOfferPageStickyHeaderMobile>}
          <CSSBreakpoint min="tablet">
            <StyledFlashHotelStickyHeader
              offer={offer}
              onViewPackageOptions={scrollToPackageOptions}
              className={clsx({ hideOnMobile: hideSoldOutOnMobile })}
            >
              {!headlessMode && <DesktopRelatedTravelItems offer={offer} />}
              <SoftOfferPageWalledGarden>
                <Backdrop visible={!!activeFilter} data-testid="filter-backdrop" />
              </SoftOfferPageWalledGarden>
              {!hideSoldOutOnMobile && <BarShadow shadow="bottom-small" background="none" />}
            </StyledFlashHotelStickyHeader>
          </CSSBreakpoint>
          {isLuxPlusEnabled && !!offer.luxPlus?.access &&
            <LuxPlusNotificationBanner>
              {offer.luxPlus.access === 'earlyAccess' && 'Members get early access to this offer before the general public and more'}
              {offer.luxPlus.access === 'memberOnly' && 'You get exclusive access to this member-only offer'}
            </LuxPlusNotificationBanner>
          }
          {availableForPurchase && offer.type === OFFER_TYPE_HOTEL &&
            <Breakpoint max="mobile">
              <FlashHotelSidebarFilters
                capacities={occupancyLimits}
              />
            </Breakpoint>
          }
          {availableForPurchase && offer.type === OFFER_TYPE_ALWAYS_ON &&
            <Breakpoint max="mobile">
              <AlwaysOnSidebarFilters
                onViewPackageOptions={scrollToPackageOptions}
                capacities={occupancyLimits}
              />
            </Breakpoint>
          }
          {shouldShowLere && <ExpiredDealsLereRecommendations
            hideOffers={!!activeFilter}
          />}
          <OfferPageGallery offer={offer} shareModalConfig={shareConfig} autoPlayVideo={!!offer.isVideoVimeoHero} />
          <Pane>
            <OfferIntro
              onViewPackageOptions={scrollToPackageOptions}
              flightDestination={destinationAirport}
              shareModalConfig={shareConfig}
            />
          </Pane>
          <ScrollAnchor ref={packageOptionsAnchor} />
          <SoftOfferPageWalledGarden>
            <PackageOptionsPane id="Package-Options">
              <LayoutContainer>
                <VerticalSpacer gap={32}>
                  {availableForPurchase && <>
                    {offer.type === OFFER_TYPE_ALWAYS_ON && !useLPCNewMobileBookingFlow && (
                      <CSSBreakpoint max="mobile">
                        <Group direction="vertical" gap={8}>
                          <OfferCapacityWithAgesSelectBox />
                          <OfferCalendarDatePickerSelectBox />
                          {showFlightInformation && <OfferAirportSelectBox />}
                        </Group>
                      </CSSBreakpoint>
                    )}
                    <CSSBreakpoint min="tablet">
                      <ScrollAnchor ref={desktopFilterBlockRef} vOffset={rem(12)} />
                      {showHotelAndFlightsToggle && (
                        <Group ref={desktopFiltersWrapperRef} fullWidth direction="horizontal" gap={8} horizontalAlign="space-between" wrap="wrap">
                          <FlexGroup direction="horizontal" horizontalAlign="center" desktopHorizontalAlign="start">
                            <HotelFlightsToggleButton />
                          </FlexGroup>
                          <FlexDesktopFilterBlock direction="horizontal" gap={8} horizontalAlign="center" desktopHorizontalAlign="end" wrap="wrap" className={clsx({ open: !!activeFilter })}>
                            {showFlightInformation && flights && <OfferAirportSelect />}
                            <OfferCapacityWithAgesSelect
                              boundaryRef={desktopFiltersWrapperRef}
                              capacities={occupancyLimits}
                            />
                            <OfferCalendarDatePickerSelect boundaryRef={desktopFiltersWrapperRef} />
                          </FlexDesktopFilterBlock>
                        </Group>
                      )}
                      {!showHotelAndFlightsToggle && (
                        <DesktopFilterBlock ref={desktopFiltersWrapperRef} direction="horizontal" gap={8} horizontalAlign="center" className={clsx({ open: !!activeFilter })}>
                          <OfferCapacityWithAgesSelect
                            boundaryRef={desktopFiltersWrapperRef}
                            capacities={occupancyLimits}
                          />
                          <OfferCalendarDatePickerSelect boundaryRef={desktopFiltersWrapperRef} />
                          {showFlightInformation && <OfferAirportSelect />}
                        </DesktopFilterBlock>
                      )}
                    </CSSBreakpoint>
                  </>}
                  {offer.type === OFFER_TYPE_ALWAYS_ON && !useLPCNewMobileBookingFlow && (
                    <VerticalSpacer gap={8}>
                      <Subtitle variant="subtitle3" align="center">
                        Select duration
                      </Subtitle>
                      <OfferDurationTabs />
                    </VerticalSpacer>
                  )}
                </VerticalSpacer>
              </LayoutContainer>
            </PackageOptionsPane>
            {isMobileDevice && availableForPurchase && <AccommodationOfferPageStickyFooter />}
            {!isMobileDevice && availableForPurchase && <HotelOfferPageStickyFooter
              visible={stickyFooterVisible}
              lowestPricePackage={offer.lowestPricePackage ?? offer.packages[0]}
              onScrollTo={scrollToPackageOptions}
              offer={offer}
            />}
            {packages.length > 0 && !canBookMultiRoomTypes && (<>
              {offer.type === OFFER_TYPE_HOTEL && !isMobileDevice && <FlashHotelPackageOptions
                onStickyFooterToggle={onStickyFooterToggle}
                showFlightInformation={showFlightInformation}
                destinationAirport={destinationAirport}
              />}
              {offer.type === OFFER_TYPE_HOTEL && isMobileDevice && <FlashHotelPackageOptionsVariant
                showFlightInformation={showFlightInformation}
              />}
              {offer.type === OFFER_TYPE_ALWAYS_ON && !useLPCNewMobileBookingFlow && <AlwaysOnRoomOptions
                showFlightInformation={showFlightInformation}
                destinationAirport={destinationAirport}
                onViewPackageOptions={scrollToPackageOptions}
              />}
              {offer.type === OFFER_TYPE_ALWAYS_ON && useLPCNewMobileBookingFlow && <AlwaysOnRoomOptionsMobile
                showFlightInformation={showFlightInformation}
              />}
            </>)}
            {canBookMultiRoomTypes && (
              <MultipleRoomsBookingContent />
            )}
          </SoftOfferPageWalledGarden>
        </RelativeBlock>
        <SoftOfferPageWalledGarden bypassWall={isWalledGardenEuropeOffersEnabled} wall={<OfferPageSignUpWall offerType="hotel" saveUpToPercent={loggedOutSavedPercent} />} />
      </OfferPageStateProvider>
    </ProductPaletteProvider>
  )
}

function mapStateToProps(state: App.State, ownProps: Partial<Props>) {
  return {
    originAirports: state.geo.originAirports,
    airports: state.geo.airports,
    defaults: getInitialLeOfferPageState(state, ownProps.offer!),
    routerLocation: state.router.location,
    currency: state.geo.currentCurrency,
    headlessMode: state.system.headlessMode,
    isMultiRoomEnabled: multiRoomEnabled(state, ownProps.offer!),
    isLuxPlusEnabled: getIsLuxPlusEnabled(state),
    routeHistory: state.routeHistory,
  }
}

export default connect(mapStateToProps)(UltraLuxContent)
